
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 150.25 150.25"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"75.12","cy":"75.12","r":"75.12","fill":"#3b7cf7"}}),_c('path',{attrs:{"d":"M89.53,34.9V49.53H61.16V30a5.32,5.32,0,0,1,5.32-5.32H84.21m-17.73,0","transform":"translate(-.67 -.67)","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M50.53,118.67V65.49a8.85,8.85,0,0,1,8.86-8.87H91.3a8.86,8.86,0,0,1,8.87,8.87v53.18a8.86,8.86,0,0,1-8.87,8.87H59.39m0-70.92","transform":"translate(-.67 -.67)","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M61.16,97.4V79.67a14.19,14.19,0,0,1,28.37,0V97.4a14.19,14.19,0,0,1-28.37,0Zm0,0","transform":"translate(-.67 -.67)","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M91.3,56.62H59.39a3.55,3.55,0,1,1,0-7.09H91.3a3.55,3.55,0,1,1,0,7.09Zm0,0","transform":"translate(-.67 -.67)","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_c('path',{attrs:{"d":"M82.44,91.3a7.52,7.52,0,0,1-7.09,7.87,7.52,7.52,0,0,1-7.1-7.87c0-3.09,3.55-8.24,5.68-10.94a1.77,1.77,0,0,1,2.83,0c2.13,2.7,5.68,7.85,5.68,10.94Zm0,0","transform":"translate(-.67 -.67)","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])
          )
        }
      }
    